import React from "react";
import EstimatedEarnings from "./EstimatedEarnings";
import { useOutletContext } from "react-router-dom";

export function CalculatorPage() {
  const { isAdmin } = useOutletContext();

  return (
    <div>
      <div className="mb-8">
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-200">
          Earnings Calculator
        </h2>
        <p className="mt-2 text-sm text-gray-400">
          Calculate estimated earnings based on map plays
        </p>
      </div>
      <div className="bg-[#18181B] rounded-xl shadow-xl shadow-black/20 p-4 sm:p-6">
        <EstimatedEarnings isAdmin={isAdmin} />
      </div>
    </div>
  );
}
